import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS START *********************** */
export const memberAccountDetailsSavingsGet = (fetchData: any) => {
	const data = {
		GetMemberAccountReportTokenForSavings: fetchData,
	};
	const url = `${API_URL}fetchMemberAccountDetailsReportForSavings`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS END *********************** */

/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT START *********************** */
export const memberAccountDetailsFixedDepositGet = (fetchData: any) => {
	const data = {
		GetMemberAccountReportTokenForFixedDeposit: fetchData,
	};
	const url = `${API_URL}fetchMemberAccountDetailsReportForFixedDeposit`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT END *********************** */
